<template>
  <div class="info-box static">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="overflow-y-auto px-2.5 flex-1"
    >
      <el-form-item
        label="到款账户"
        prop="bank_account_id"
        :rules="[
          { required: true, message: '请选择到款账户', trigger: 'blur' },
        ]"
      >
        <el-select v-model="state.model.bank_account_id" filterable>
          <template #label="{ value }">
            <div
              v-if="zh_map.get(value)"
              class="grid w-full gap-x-10 items-center"
              style="grid-template-columns: 1fr auto"
            >
              <text>{{ zh_map.get(value).opening_bank }}</text>
              <text class="text-gray-400 text-xs">
                {{ zh_map.get(value).name + "-" + zh_map.get(value).account }}
              </text>
            </div>
          </template>
          <el-option
            v-for="item in state.zh_data"
            :key="item.id"
            :label="`${item.opening_bank} ${item.name} ${item.account}`"
            :value="item.id"
          >
            <div
              class="grid w-full gap-x-10 items-center"
              style="grid-template-columns: 1fr auto"
            >
              <text>{{ item.opening_bank }}</text>
              <text class="text-gray-400 text-xs">
                {{ item.name + "-" + item.account }}
              </text>
            </div>
          </el-option>
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadZh()"
            >
              刷新
            </el-button>
          </template>
        </el-select>
      </el-form-item>
      <ul class="grid gap-x-5" style="grid-template-columns: 1fr auto">
        <el-form-item
          label="转账日期"
          prop="receipt_date"
          :rules="[
            { required: true, message: '请选择转账日期', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!state.model.receipt_time)
                  return callback(new Error('请选择转账时间'));
                else callback();
              },
              trigger: 'blur',
            },
          ]"
        >
          <div class="grid items-center gap-x-2 grid-cols-2" style="tem">
            <el-date-picker
              v-model="state.model.receipt_date"
              type="date"
              placeholder="转账日期"
              value-format="YYYY-MM-DD"
              class="!w-full"
            />
            <el-time-picker
              v-model="state.model.receipt_time"
              arrow-control
              placeholder="转账时间"
              class="!w-full"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
        </el-form-item>
        <el-form-item label="到款金额">
          <el-input-number
            v-model="state.model.receipt_amount"
            :precision="2"
            class="number-input-left number-input-suffix !w-28"
            suffix="元"
            @focus="$onFocus"
          ></el-input-number>
        </el-form-item>
      </ul>
      <ul class="grid grid-cols-3 gap-x-3">
        <el-form-item label="付款银行">
          <el-input v-model="state.model.payment_opening_bank"></el-input>
        </el-form-item>
        <el-form-item label="付款户名">
          <el-input v-model="state.model.payment_name"></el-input>
        </el-form-item>
        <el-form-item label="付款账号">
          <el-input v-model="state.model.payment_account"></el-input>
        </el-form-item>
      </ul>
      <el-form-item label="到款说明">
        <el-input v-model="state.model.remark" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="附件">
        <template #label>
          <div class="flex items-center">
            <text>附件</text>
            <el-upload
              :show-file-list="false"
              :auto-upload="false"
              multiple
              :on-change="onFileChange"
            >
              <el-button type="primary" size="small" link icon="plus">
                上传
              </el-button>
            </el-upload>
          </div>
        </template>
        <div class="w-full">
          <li
            v-for="(file, index) in state.model.files"
            class="grid items-center"
            style="grid-template-columns: 1fr auto;"
          >
            <text>{{ file.origin_filename }}</text>
            <el-icon
              color="#f00"
              @click.stop="state.model.files?.splice(index, 1)"
              class="hover:scale-110 text-red-400 cursor-pointer"
            >
              <Close />
            </el-icon>
          </li>
        </div>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit"> 提交 </el-button>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref } from "vue";
import {
  bankReceipt_detail,
  bankReceipt_add,
  bankReceipt_edit,
} from "@/http/bankReceipt";
import { data_getBankAccount } from "@/http/data";
import { attachment_upload } from "@/http/attachment";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
    });
    onMounted(() => {
      onLoadZh();
      if (props.id) {
        bankReceipt_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            state.model.files = data.attachment.map((m) => {
              return {
                id: m.id,
                origin_filename: m.filename,
                file_url: m.file_url,
              };
            });
          }
        });
      }
    });

    //获取银行账户
    const onLoadZh = () => {
      data_getBankAccount().then((res) => {
        if (res.status == 200) state.zh_data = res.data?.data?.list || [];
      });
    };

    //银行账户 id 索引，O(1) 查找
    const zh_map = computed(() => {
      const m = new Map();
      state.zh_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          state.model.files = [...state.model.files, ...res.data.data];
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.model.attachment = JSON.stringify(
            state.model.files?.map((m) => m.id),
          );

          if (props.id) {
            bankReceipt_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            bankReceipt_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      zh_map,
      onLoadZh,
      onSubmit,
      onFileChange,
    };
  },
};
</script>
<style scoped></style>
